








import { Vue, Component, Prop } from 'vue-property-decorator';

type TableConfig = {
  layout?: 'auto' | 'fixed';
};

function defaultConfig(): TableConfig {
  return {
    layout: 'auto'
  };
}

@Component({})
export default class Table extends Vue {
  @Prop({ default: () => defaultConfig() }) config?: TableConfig;

  get scopedStyles() {
    return {
      ...(this.config && {
        '--scoped-table-layout': this.config.layout
      })
    };
  }
}
